import { WidgetStrategyWithConfig } from 'widgets/WidgetRegistry';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { MyPortfolioCapsulesWidget } from 'widgets/myPortfolioCapsules/components/MyPortfolioCapsulesWidget';
import { buildMyPortfolioCapsulesConfigSlice } from 'widgets/myPortfolioCapsules/store/config/configSlice';
import { MyPortfolioCapsulesWidgetConfigState } from 'widgets/myPortfolioCapsules/store/config/MyPortfolioCapsulesWidgetConfigState';
import { myPortfolioCapsulesDescription } from 'widgets/myPortfolioCapsules/components/description/myPortfolioCapsulesDescription';
import State from 'store/State';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';
import { PortfolioItemColumn } from 'portfolio/PortfolioItem';
import { getTopic } from 'widgets/myPortfolioCapsules/topics/Topic';

const {
    initialConfigState,
    selectors: { selectConfigState },
} = buildMyPortfolioCapsulesConfigSlice();

export const myPortfolioCapsulesWidgetStrategy: WidgetStrategyWithConfig<MyPortfolioCapsulesWidgetConfigState> =
    {
        title: 'Portfolio Capsules',
        supportedHosts: ['layout'],
        reactComponentType: MyPortfolioCapsulesWidget,
        categories: [WidgetCategory.PORTFOLIO],
        description: myPortfolioCapsulesDescription,
        portfolioSelectionRequirements:
            PortfolioSelectionRequirements.Portfolio,
        initialConfigState,
        getRequiredPortfolioColumns,
        enableTitleEditing: true,
    };

function getRequiredPortfolioColumns(
    state: State,
    widgetKey: string,
    _symbology: SymbologyValues
): PortfolioItemColumn[] {
    const config = selectConfigState(state, widgetKey);
    const { topic } = config;
    if (!topic) {
        return [];
    }
    return [
        'qtyTraded',
        'qtyRemaining',
        ...getTopic(topic).requiredPortfolioColumns,
    ];
}
